import $ from 'jquery'

const $product_title = $('.product_title')

$(document).ready(function() {
    const container = $('.flex-control-nav');
    const $product_cta = $('.product-cta-container')
    if (container.length === 0) {
        $('.woocommerce-product-gallery').addClass('remove-gradient')
    }

    if($product_cta.length !== 0) {
        $('.woocommerce-product-gallery__wrapper a img').addClass('cta-margin')
    }

    container.on( 'scroll', function() {
        let scrollTop = container.scrollTop();
        let visibleHeight = container.height();
        let scrollHeight = container[0].scrollHeight;

        if (scrollTop + visibleHeight >= scrollHeight) {
            $('.woocommerce-product-gallery').addClass('remove-gradient')
        } else {
            $('.woocommerce-product-gallery').removeClass('remove-gradient')
        }
    });
})

$(window).on('load', () => {
    const slider = $('.flex-control-nav');
    const slider_images = $('.flex-control-nav img')
    if (slider.length === 0) return;
    let isDown = false;
    let startX;
    let scrollLeft;
    let $scrolled = false

    slider.on('mousedown', function(e) {
        isDown = true;
        startX = e.pageX - $(this).offset().left;
        scrollLeft = $(this).scrollLeft();
    });

    slider.on('mouseleave', function() {
        isDown = false;
    });

    slider.on('mouseup', function() {
        isDown = false;
    });

    slider.on('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - $(this).offset().left;
        const walk = x - startX;
        $(this).scrollLeft(scrollLeft - walk);
    });

    //for mobile
    slider.on('touchstart', function(e) {
        e.stopPropagation();
        startX = e.changedTouches[0].pageX - $(this).offset().left;
        scrollLeft = $(this).scrollLeft();
    });

    slider.on('touchmove', function(e) {
        e.stopPropagation();
        e.preventDefault();
        const x = e.changedTouches[0].pageX - $(this).offset().left;
        const walk = x - startX;
        $(this).scrollLeft(scrollLeft - walk);
        $scrolled = true
    });

    slider_images.on('touchend', function(e) {
        if($scrolled === true) {
            e.stopPropagation();
            e.preventDefault()
            $scrolled = false
        }
    })
});

$('.product-cta-container_link').on('click', () =>{
    sessionStorage.setItem('product_name', $product_title.text())
})
